// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageAdminSalary {\n  padding: 16px; }\n  .PageAdminSalary .PageAdminSalary__table {\n    display: table;\n    width: 100%;\n    border: 1px solid lightgray;\n    border-collapse: collapse;\n    border-spacing: 0; }\n    .PageAdminSalary .PageAdminSalary__table th {\n      font-size: 9px; }\n    .PageAdminSalary .PageAdminSalary__table td {\n      font-size: 11px; }\n", ""]);
// Exports
module.exports = exports;
